export default {
    notes_create_new_note: "New Note",
    notes_create_edit_note: "Edit Note",
    notes_create_success_message: "The note has been created",
    notes_update_success_message: "The note has been edited",
    notes_note: "Note",
    notes_create_show_note: "View",
    notes_min_length: "The note need to have at least 3 characters",
}